import React, { useState } from 'react'
import { Redirect, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { formatPrice } from '../common/Functions';

function Footer({ totalAll, isContinueOrder }) {
    const lsShowPopup = localStorage.getItem('showMultipleOrderPopup');
    const [donotshow, setDonotshow] = useState(false);
    const [showPopup, setShowPopup] = useState(lsShowPopup == 'true' ? true : false);
    const history = useHistory();
    const [close, SetClose] = useState(false);

    if (close) {
        return <Redirect to="/" />

    }

    const closeMe = () => {
        SetClose(true);
    }

    const redirectToPayment = () => {
        history.push("/payment");
    }


    return (
        <footer className="pg-table-booking">
            {/*!showPopup && <div className="floating-info active">
                <p>You can continue adding items from the menu and choose to make the payment later</p>
                <div className="bottom">
                    <div className="custom-checkbox">
                        <input type="checkbox" checked={donotshow} value="1" onChange={(event) => setDonotshow(event.target.checked)} />
                        <span className="checkmark"></span>
                    </div>
                    <span>Do not show this message again</span>
                    <span className="close-floating-info fa fa-close" onClick={() => { setShowPopup(true); localStorage.setItem('showMultipleOrderPopup', donotshow) }}></span>
                </div>
    </div>*/}
            <div className="total-cart-bottom">
                <span className="text-white d-inline-block font-bold">GRAND TOTAL</span>
                <span className="font-bold text-white ">{formatPrice(totalAll)} </span>
            </div>
            {isContinueOrder > 0 && <div className="continue-ordering text-right">
                <a className="text-white" onClick={closeMe}>Continue Ordering</a>
            </div>}
            <div className="bottom-action" onClick={redirectToPayment}>
                <div className="left">
                    <p className="text-white"><span className="text-white d-inline-block pr-10">Total</span><span className="font-bold"> {formatPrice(totalAll)}</span></p>

                </div>
                <div className="right">
                    <button className="btn-bottom text-white">Make Payment <span className="fa fa-long-arrow-right"></span></button>
                </div>
            </div>
        </footer>
    )
}

const mapStateToProps = (state) => ({
    isContinueOrder: state.table.isContinueOrder
})

export default connect(mapStateToProps, {})(Footer)  
